// extracted by mini-css-extract-plugin
export default {"section":"ProjectLogo_section__Sskyd"};